import React, { useState } from "react";
import { Label, SpinButton } from "../components/utils/Form.jsx";
import {Fotter, Header, Section} from "../components/layout";
import { BaseUrl } from "../server.js";
import Heading from "../components/Heading";
import { Link, useNavigate } from "react-router-dom";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useStateContext } from "../context/ContextProvider.js";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import axios from "axios";

function Login() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);


  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    password: "",
  });
  const { currentDir } = useStateContext();
  const [isLoadingCreate, setIsLoadingCreate] = useState(false);
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    setIsLoadingCreate(true);
    e.preventDefault();
    const config = { headers: { "Content-Type": "application/json" ,
      
        withCredentials: true,}
      
    };
    await axios
      .post(`${BaseUrl}/user/login`, (formData),       
        {withCredentials: true,})
      .then((res) => {
    
        setIsLoadingCreate(false);       
         toast.success(<span className="font-kufi dark:text-tcolor-1 text-tcolor-4 text-sm">{t("Login Success!")}</span>);
        navigate("/admin");
        window.location.reload(true);
      })
      .catch((err) => {
        setIsLoadingCreate(false);
        toast.error(<span className="font-kufi dark:text-tcolor-1 text-tcolor-4 text-sm">{t(err.response.data.message)}</span>);

      });
  };

  return (<>
  <Header />
    <Section>
      <div className="container pt-10 ">
        <Heading title={t("Login your account")} />
        <form
          onSubmit={handleSubmit}
          className="w-full mx-auto bg-n-1 dark:bg-back-darksecondary backdrop-blur-xl rounded-lg shadow dark:border md:mt-0 sm:max-w-md border border-n-1/10  xl:p-10 p-5"
        >
          <Label
            labelText="Email"
            value={formData.email}
            onChange={handleChange}
            required={true}
            type="text"
            name="email"
          />

          <div className="relative">
            <Label
              labelText="Password"
              value={formData.password}
              onChange={handleChange}
              required={true}
              type={visible ? "text" : "password"}
              name="password"
            />
            {visible ? (
              <AiOutlineEye
                className={` text-color-1/80 dark:text-n-1/80  absolute ${
                  currentDir == "ltr" ? "right-2" : "left-2"
                } top-3 cursor-pointer`}
                size={25}
                onClick={() => setVisible(false)}
              />
            ) : (
              <AiOutlineEyeInvisible
                className={`text-tcolor-6 dark:text-n-1/80 absolute ${
                  currentDir == "ltr" ? "right-2" : "left-2"
                } top-3 cursor-pointer`}
                size={25}
                onClick={() => setVisible(true)}
              />
            )}
          </div>

          <div className="flex flex-col items-center mx-auto">
            {" "}
            <SpinButton isLoading={isLoadingCreate}>{t("Sign in")}</SpinButton>
          </div>
          <Link to="/ForgetPassword">   <p className="body-2 mt-2 text-tcolor-6/50 dark:text-n-1/50">{t("Forget my password")}</p></Link>
          <div className ="w-full mt-5 flex flex-row">
     <p className="body-2 mt-2 text-tcolor-6/50 dark:text-n-1/50">{t("don't have account ?")}</p>
  <Link to="/SignUp">   <p className="body-2 underline mt-2 mx-3 text-color-1" >{t("Sign up")}</p></Link></div>

        </form>
      </div>
    </Section>
    <Fotter />
    </>
  );
}

export default Login;
